module.exports = __webpack_public_path__ + "img/poster_video.07e0a505.png";